import React from "react";
import img1 from "./Photos/image1.png";
import img2 from "./Photos/image2.png";
import img3 from "./Photos/image3.png";
import img4 from "./Photos/image4.png";
import img5 from "./Photos/image5.png";
import img6 from "./Photos/image6.png";
import img7 from "./Photos/image7.png";
import img8 from "./Photos/image8.png";
import img9 from "./Photos/image9.png";

function TableView() {
  return (
    <div className="img-container">
      <div className="img-content1">
        <table>
          <tbody>
            <tr>
              <td colSpan={2}>
                <img src={img1} id="table-img1" alt="table-img1"/>
              </td>
            </tr>
            <tr>
              <td>
                <img src={img4} id="table-img4" alt="table-img4"/>
              </td>
              <td rowSpan={2}>
                <img src={img5} id="table-img5" alt="table-img5"/>
              </td>
            </tr>
            <tr>
              <td>
                <img src={img7} id="table-img7" alt="table-img7"/>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="img-content2">
        <table>
          <tbody>
            <tr>
              <td>
                <img src={img2} id="table-img1" alt="table-img1"/>
              </td>
              <td>
                <img src={img3} id="table-img2" alt="table-img2"/>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <img src={img6} id="table-img6" alt="table-img6"/>
              </td>
            </tr>
            <tr>
              <td>
                <img src={img8} id="table-img7" alt="table-img7"/>
              </td>
              <td>
                <img src={img9} id="table-img8" alt="table-img8"/>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TableView;
